import $ from 'jquery';
import 'jquery-mousewheel';
import * as dayjs from 'dayjs'
import { PlayMode, ApiVersion, VideoErrorStatus } from '@/constants';
import store from '@/store';
import Offline from '@/api/offline';

function seek(vm, secs) {
	let time = vm.player.currentTime() + secs;
	if (time < 0) {
		time = 0;
	}
	vm.player.currentTime(time);
}

let videoPlayerMixin = {
	methods: {
		tsc(t) {
      return this.$t("lang.storeSearch." + t);
    },
		checkUseragent() {
			const agent = window.navigator.userAgent.toLowerCase();
			if(agent.indexOf('windows') > -1) this.isSafari = false;
			else if(agent.indexOf('macintosh') > -1) {
				if(agent.indexOf('chrome') > -1) this.isSafari = false;
				else if(agent.indexOf('firefox') > -1) this.isSafari = false;
				else if(agent.indexOf('op') > -1) this.isSafari = false;
				else this.isSafari = true;
			}
			else if(agent.indexOf('iphone') > -1) {
				if(agent.indexOf('crios') > -1) this.isSafari = false; // iPhone Chrome
				else if(agent.indexOf('fxios') > -1) this.isSafari = false;
				else this.isSafari = true; // Safari
			}
			else if(agent.indexOf('ipad') > -1) {
				if(agent.indexOf('crios') > -1) this.isSafari = false; // iPad Chrome
				else this.isSafari = true; // Safari
			}
			else if(agent.indexOf('android') > -1) this.isSafari = false;
			else if (agent.indexOf('linux') > -1) this.isSafari = false;
			else this.isSafari = false;
		},
		async changeSwipeDate() {
			if (this.previousClickSwipeItem == null || this.clickSwipeItem !== this.previousClickSwipeItem) {
				this.previousClickSwipeItem = this.clickSwipeItem; // 똑같은 아이템을 클릭한 경우에는 업데이트 하지 않음
												
				// 초기 화면에 보여줄 swipeDates 설정
				if (this.swipeDates.length === 0) {
						this.swipeDates = [];
						const swipeEndDate = new Date(); // 오늘 날짜가 마지막 날짜
						const startDate = new Date(swipeEndDate); // 시작 날짜 계산
						startDate.setDate(swipeEndDate.getDate() - 13);
						const endDate = new Date(swipeEndDate); // 종료 날짜 계산
						endDate.setDate(swipeEndDate.getDate());
						this.dates.forEach((item) => {
								const itemDate = new Date(item);
								// item이 기간에 포함되는지 확인
								if (itemDate >= startDate && itemDate <= endDate && !this.swipeDates.includes(item)) {
										this.swipeDates.push(item);
								}
						});
				} else {
						this.swipeDates = [];
						const swipeEndDate = new Date(this.clickSwipeItem);
						const startDate = new Date(swipeEndDate); // 시작 날짜 계산
						startDate.setDate(swipeEndDate.getDate() - 6);
						const endDate = new Date(swipeEndDate); // 종료 날짜 계산
						endDate.setDate(swipeEndDate.getDate() + 6);
						this.dates.forEach((item) => {
								const itemDate = new Date(item);
								// item이 기간에 포함되는지 확인
								if (itemDate >= startDate && itemDate <= endDate && !this.swipeDates.includes(item)) {
										this.swipeDates.push(item);
								}
						});
				}
		}
        },
		clickSwipeDate(date) {
			this.mouseDownOnSwiper = true;
			this.clickSwipeItem = date;
			console.log('clickSwipeDate', date);
      this.hideClipDetail();
      if(this.isClipCreate) this.removeClip();
      const clickDate = new Date(date);
      const currDate = new Date(this.playPoint);
      if(clickDate.toDateString() !== currDate.toDateString()) {
      	clickDate.setHours(currDate.getHours());
        clickDate.setMinutes(currDate.getMinutes());
        clickDate.setSeconds(currDate.getSeconds());
        this.playerOndemandPlay({
          playPoint : clickDate, 
          type : 'calendar',
        });
      }
    },
		async loadPreviousItems() {
			this.isClicking = true;
			
			if (this.dates.length == 8) {
				await this.fetchKvsMetricDate();
			}
			const swipeBeginDate = new Date(this.swipeDates[0]); // 가장 앞에 있는 날짜
			const index = this.dates.findIndex(date => new Date(date).toISOString() === swipeBeginDate.toISOString());
					
			let swipeDates = [];
			if (index !== -1) {
				for (let i = Math.max(index - 6, 0); i <= Math.min(index + 6, this.dates.length - 1); i++) {
					if (this.dates[i] !== undefined) {
						swipeDates.push(this.dates[i]);
					}
				}
				this.swipeDates = swipeDates;
			}
					
			this.swipeDates.sort((a, b) => {
				const dateA = new Date(a);
				const dateB = new Date(b);
				return dateA - dateB;
			});
			setTimeout(() => {
				this.isClicking = false;
			})

		},	
		async loadNextItems() {
			this.isClicking = true;
			
			if (this.dates.length == 8) {
				await this.fetchKvsMetricDate();
			}
			const swipeEndDate = new Date(this.swipeDates[this.swipeDates.length - 1]); // 가장 뒤에 있는 날짜
			const index = this.dates.findIndex(date => new Date(date).toISOString() === swipeEndDate.toISOString());
				
			let swipeDates = [];
			if (index !== -1) {
				for (let i = Math.max(index - 6, 0); i <= Math.min(index + 6, this.dates.length - 1); i++) {
					if (this.dates[i] !== undefined) {
						swipeDates.push(this.dates[i]);
					}
				}
				this.swipeDates = swipeDates;
			}
					
			this.swipeDates.sort((a, b) => {
				const dateA = new Date(a);
				const dateB = new Date(b);
				return dateA - dateB;
			});
			setTimeout(() => {
				this.isClicking = false
			})
		},
		toOndemand(status, dragStopTimeDate) {
      if (this.isWebRTCPlaying) {
        this.pushRoute('/video-player', {
         demandSDate: encodeURIComponent(dragStopTimeDate),
        });
        this.$router.go();
      }
			this.videoLoading = true;
			this.showClipTab = false;
			let currentDate = new Date(this.videoSegmentStartDateObj.getTime() + (this.playCurrentTime * 1000) );
      let diffTime = (currentDate.getTime() - dragStopTimeDate.getTime()) / (1000*60); // 단위 분(m)
			if(status == 'live') { // live일때 요청한 경우
				this.getStreamingUrl(this.streamData.streamName, 
					dragStopTimeDate.toISOString(), diffTime > 59 
					? new Date(dragStopTimeDate.getTime() + 3590000).toISOString() 
					: currentDate.toISOString());
			} else { // ondemand일때 요청한 경우
				this.getStreamingUrl(this.streamData.streamName, 
					dragStopTimeDate.toISOString(), 
						new Date(dragStopTimeDate.getTime() + 1800000).toISOString());
			}
      //pc onDemand인 경우 ptz 버튼 hide
      this.hidePtzControlFunc();
			console.log(`%cOndemand video RequestTime = ${new Date(currentDate.getTime() - 3600000)}`, "color:#008DD0;");
    },
    toWebRTCDCHLive() {
      this.$store.commit('player/SET_OFFLINE_TIME_DIFF_ADJ', this.player.currentTime() - this.playerInitTime);
      const offline = new Offline();
      offline.sendMessage('live');
      this.$store.commit('player/SET_VIDEO_SEGMENT_START_DATE_OBJ', new Date());
      this.videoPlay();
      this.$store.commit('player/SET_VIDEO_PLAY_STATUS', true);
      if (this.playPauseBtnDom) this.playPauseBtnDom.innerHTML = "<img src='" + this.pauseImagePath + "' style='width:25px; height:25px;' />";
      else if (this.$refs.videoBox) this.$refs.videoBox.playPauseBtnDom.innerHTML = "<img src='" + this.$refs.videoBox.pauseImagePath + "' style='width:25px; height:25px;' />";
    },
    toOfflineLive() {
      this.$store.commit('player/SET_OFFLINE_TIME_DIFF_ADJ', this.player.currentTime() - this.playerInitTime);
      const offline = new Offline();
      offline.sendMessage('live');
      offline.sendMessage('timelist', { date : new Date().toISOString().substring(0, 10).replaceAll('-', '') });
      this.$store.commit('player/SET_VIDEO_SEGMENT_START_DATE_OBJ', new Date());
      this.videoPlay();
      this.$store.commit('player/SET_VIDEO_PLAY_STATUS', true);
      if (this.playPauseBtnDom) this.playPauseBtnDom.innerHTML = "<img src='" + this.pauseImagePath + "' style='width:25px; height:25px;' />";
      else if (this.$refs.videoBox) this.$refs.videoBox.playPauseBtnDom.innerHTML = "<img src='" + this.$refs.videoBox.pauseImagePath + "' style='width:25px; height:25px;' />";
    },
    async toLive(playMode) {
			if (playMode === PlayMode.KVS_LIVE) {
				store.dispatch('player/changePlayMode', PlayMode.KVS_LIVE);
			} else {
        const { contractCd, portNo } = this.cameraInfo;
        const isFull = await this.checkSessionLimitFull(contractCd, portNo);
        if (isFull && this.playMode !== PlayMode.PLAYBACK) {
          this.$dialog.confirm({
            text: this.t('errorMsgMaxSession'),
            actions: {
              true: {
                color: 'white',
                text: this.t('confirm'),
                handle: () => {
                  this.$store.commit('player/SET_VIDEO_ERROR', VideoErrorStatus.NO_ERROR);
                }
              }
            }
          });
          return;
        }
        store.dispatch('player/changePlayMode', PlayMode.KVS_WEBRTC_LIVE); // offline일 경우 WEBRTC_LIVE로 모드 변경함
        if (this.playMode === PlayMode.WEBRTC_LIVE) this.toOfflineLive();
        else if (this.playMode === PlayMode.KVS_WEBRTC_DCH) this.toWebRTCDCHLive();
			}
      this.hideClipDetail();
      this.mobileCurrentPlayRate = 3;
			this.clickSwipeItem = this.getFormatDate(new Date(), 'normal').substring(0,10);
      this.activeIndex = this.clickSwipeItem.substring(8,18);
			console.log('%cLive Video!', "color:#008DD0;");
    },
    getStreamingUrlPromise(streamName, beginDate, endingDate) {
			this.makeVideoStartTime(beginDate);
			return new Promise(async (resolve, reject) => {
        let params = {};
				const res = await this.networkController.getHlsStreamingUrl(params, streamName, beginDate, endingDate);
        if (res.status === 200) resolve(res.data.hlsstreamingSessionURL);
        reject(new Error());
				// 	this.showToastMessage(this.t('noStreamingData'));
			});
		},
		getStreamingUrl(streamName, beginDate, endingDate) {
			this.makeVideoStartTime(beginDate);
			if(this.authorities.ADD_BOOKMARK && this.$store.state.isMobile == false) {
				this.player.controlBar.children_[5].el_.disabled = true;
				$('.vjs-control.vjs-button.marker_btn').attr('style', 'opacity: 0.4 !important');
			}
			const promise = new Promise((resolve, reject) => {
				let params = {};
				this.networkController.getHlsStreamingUrl(params, streamName, beginDate, endingDate).then(async (res) => {
					this.videoStreamingUrl = res.data.hlsstreamingSessionURL;
					resolve()
				}).catch(error => {
					this.showToastMessage(this.t('noStreamingData'));
					reject()
				});
			});
			promise.then(() => {
				if(VideoErrorStatus.isOfflineStatus(this.videoError)) {
          this.$store.commit('player/SET_VIDEO_ERROR', VideoErrorStatus.NO_ERROR);
					this.player.src({
						src: `${this.videoStreamingUrl}`,
						type: 'application/x-mpegURL'
					});
          this.videoPlay();
				} else {
					this.player.src({
						src: `${this.videoStreamingUrl}`,
						type: 'application/x-mpegURL'
					});
					if(this.videoPlayStatus) this.videoPlay();
					else {
						if(!this.onDemand) this.videoPlay();
					}
				}
			});
		},
		makeVideoStartTime(startDateISOString) {
			// video segment 데이터에서 동영상 시작시간을 구하지 못할경우를 대비해서
			// 직접 동영상 시작시간을 구하는 함수
			if(startDateISOString == '') { // Live
				this.$store.commit('setVideoStartTimeDateObj', new Date());
			} else { // OnDemand
				this.$store.commit('setVideoStartTimeDateObj', new Date(startDateISOString));
			}
		},
    hideClipDetail() {
      //clip 그려져 있을 경우 삭제
      $('#detect_info').css({'display': 'block'});
      $('#clip_detail').css({'display': 'none'});
    },
		createScreenshot() {
			$("#screenshot_mask").css({'left': `${this.currentBookmarkIconPosition}px`});
				document.getElementById('screenshot_mask').style.display = 'block';
			let blob = this.createImageAndConvertBlob(document.getElementById(this.player.id() + "_html5_api"),
				document.getElementById("my-video").getBoundingClientRect().width, document.getElementById("my-video").getBoundingClientRect().height);
				
			let url = URL.createObjectURL(blob);
			console.log('url', url);
			let a = document.createElement('a');
			a.href = url;
			const currentDate = new Date(this.videoSegmentStartDateObj.getTime() + (this.playCurrentTime * 1000) );
			// a.download = this.streamData.cameraName + '_' + this.getFormatDate(new Date(), 'default');
			a.download = this.streamData.cameraName + '_' + this.getFormatDate(currentDate, 'default');
			document.body.appendChild(a);
			a.click();

			setTimeout(function () {
				document.body.removeChild(a);
				$('#screenshot_mask').fadeOut(400);
				$("#screenshot_tooltip").css({'left': `${this.currentBookmarkIconPosition}px`});
				document.getElementById('screenshot_tooltip').style.display = 'block';
				setTimeout(function() {
					$('#screenshot_tooltip').fadeOut(400);
				}, 1000);
			}, 100);
		},
		tagAddSuccess(tag) {
			this.tagList.push({
				contractCd: this.streamData.contractCd,
				portNo: this.streamData.portNo,
				tagName: tag
			});
		},
    async deleteTag(item) {
      let params = {};
      this.tagLoading = true;
      await this.networkController.deleteTag(params, this.streamData.contractCd, item.id)
      .then(async (res) => {
        //tag 목록 새로고침 
			  this.networkController.getTagList(params, this.streamData.contractCd, this.streamData.portNo)
			  .then(async (res) => {
			  	console.log('%cTag List\n', "color:#008DD0;", res.data);
			  	this.tagList = res.data;
					this.showToastMessage(this.tmb('successDeleteTag'));
          this.tagLoading = false;
			  }).catch(error => {
          console.log(error);
          this.tagLoading = false;
        });
      }).catch(error => {
        console.log(error);
          this.tagLoading = false;
      });
    },
    tagDeleteSuccess(tag) {
      let params = {};
      let cameraTagList = [];
      this.networkController.getTagList(params, this.streamData.contractCd, this.streamData.portNo)
      .then(async (res) => {
        cameraTagList = res.data;
        let index = cameraTagList.findIndex(r => r.tagName == tag);
        this.deleteTag(cameraTagList[index]);
      }).catch(error => {
        
      });
    },
		videoPlay() {
      let nowPlaymode = this.playMode;
      console.log('videoPlay', nowPlaymode);
      if (nowPlaymode === PlayMode.PLAYBACK) {
        this.offline = new Offline();
        this.offline.sendMessage('resume');
      }
      this.player.play();
    },
    videoPause() {
      let nowPlaymode = this.playMode;
      console.log('videoPause', nowPlaymode);
      if (nowPlaymode === PlayMode.PLAYBACK) {
        this.offline = new Offline();
        this.offline.sendMessage('pause');
      }
      this.player.pause();
    },
		videoForward(vm) {
      let nowPlaymode = this.playMode;
      if (nowPlaymode === PlayMode.WEBRTC_LIVE || nowPlaymode === PlayMode.PLAYBACK) {
        const target = new Date(vm.playPoint);
        target.setSeconds(target.getSeconds() + 15);
        if (new Date() < target) this.toOfflineLive();
        else {
          let controller = vm;
          if (vm.$parent.playerOndemandPlay) controller = vm.$parent;
          controller.playerOndemandPlay({
            type: "video-forward",
            playPoint: target,
          });
        }
        return;
      }
      let time = this.playCurrentTime + 15;
      let videoSegmentStartDateObj = this.$store.getters.getVideoStartTimeDateObj;
      let currentDate = new Date(videoSegmentStartDateObj.getTime() + (this.playCurrentTime * 1000));
      let setEndingDate = new Date(videoSegmentStartDateObj.getTime() + (this.playCurrentTime * 1000));
      let beginDate = new Date(currentDate.setSeconds(currentDate.getSeconds() + 15)).toISOString();
      let endingDate = new Date(setEndingDate.setMinutes(setEndingDate.getMinutes() + 45)).toISOString();
      if(new Date() < new Date(currentDate.setSeconds(currentDate.getSeconds() + 15))) {
        this.toLive(nowPlaymode);
      } else {
        this.getStreamingUrl(vm.streamData.streamName, beginDate, endingDate);
      }
    },
		// checkOndemandVideoForwardTime(time) {
		// 	// 비디오 영상 재생시간이 현재시간을 따라잡았는지 확인하는 함수
		// 	const currentVideoPlayTime = new Date(this.videoSegmentStartDateObj.getTime() + (time * 1000)).getTime();
		// 	if(currentVideoPlayTime > this.currentDateTime - 6000) {
		// 		return true;
		// 	} else {
		// 		return false;
		// 	}
		// },
    videoTimeMove(vm, demandSDate, demandEDate) {
      let beginDate, endingDate;
      if (demandSDate) beginDate = new Date(demandSDate).toISOString();
      if (demandEDate) endingDate = new Date(demandEDate).toISOString();
      if (beginDate && !endingDate) {
        const temp = new Date(demandSDate);
        endingDate = new Date(temp.setMinutes(temp.getMinutes() + 30)).toISOString();
      }
      this.clickSwipeItem = beginDate.substring(0, 10);
      this.hidePtzControlFunc();
      this.getStreamingUrl(vm.streamData.streamName, beginDate, endingDate);
    },
		videoRewind(vm) {
			let nowPlaymode = this.playMode;
			if (nowPlaymode === PlayMode.WEBRTC_LIVE || nowPlaymode === PlayMode.PLAYBACK) {
        const target = new Date(vm.playPoint);
        target.setSeconds(target.getSeconds() - 15);
        let controller = vm;
        if (vm.$parent.playerOndemandPlay) controller = vm.$parent;
        controller.playerOndemandPlay({
          type: 'video-rewind',
          playPoint: target,
        });
        return;
      }
			let time = this.playCurrentTime - 15;
			let currentDate = new Date(this.videoSegmentStartDateObj.getTime() + (this.playCurrentTime * 1000));
			let setEndingDate = new Date(this.videoSegmentStartDateObj.getTime() + (this.playCurrentTime * 1000));
			let beginDate = new Date(currentDate.setSeconds(currentDate.getSeconds() - 15)).toISOString();
			let endingDate = new Date(setEndingDate.setMinutes(setEndingDate.getMinutes() + 30)).toISOString();

			if(nowPlaymode == PlayMode.KVS_ON_DEMAND) { // onDemand 영상
				if(time >= 0) {
					vm.player.currentTime(time);
				} else {
					this.getStreamingUrl(vm.streamData.streamName, beginDate, endingDate);
					this.$store.commit('player/SET_ON_DEMAND_BEGIN_DATE', beginDate);
				}
			} else { // Live 영상 
				this.hidePtzControlFunc();
				this.getStreamingUrl(vm.streamData.streamName, beginDate, endingDate);
				this.$store.commit('player/SET_ON_DEMAND_BEGIN_DATE', beginDate);
				this.$store.dispatch('player/changePlayMode', PlayMode.KVS_ON_DEMAND);
			}
		},
		scrollZoom(container, max_scale, factor) {
			var target = container.children().first();
			var size = { w: target.width(), h: target.height() };
			var pos = { x: 0, y: 0 };
			var zoom_target = { x: 0, y: 0 };
			var zoom_point = { x: 0, y: 0 };
			var scale = 1;
			target.css('transform-origin','0 0');
			target.css('transition','all 0.5s;');
			target.on("mousewheel DOMMouseScroll", async (e) => {
				this.mouseZoomScroll = await true;
				var offset = container.offset();
				zoom_point.x = e.pageX - offset.left;
				zoom_point.y = e.pageY - offset.top;
		
				e.preventDefault();
				var delta = e.delta || e.originalEvent.wheelDelta;
				if (delta === undefined) {
					//we are on firefox
					delta = e.originalEvent.detail;
				}
				delta = Math.max(-1, Math.min(1, delta)); // cap the delta to [-1,1] for cross browser consistency
		
				// determine the point on where the slide is zoomed in
				zoom_target.x = (zoom_point.x - pos.x) / scale;
				zoom_target.y = (zoom_point.y - pos.y) / scale;
		
				// apply zoom
				scale += delta * factor * scale;
				scale = Math.max(1, Math.min(max_scale, scale));
				// console.log(scale);
				this.zoomScale = Math.floor(scale * 10);
		
				// calculate x and y based on zoom
				pos.x = -zoom_target.x * scale + zoom_point.x;
				pos.y = -zoom_target.y * scale + zoom_point.y;
		
				// Make sure the slide stays in its container area when zooming out
				if(pos.x > 0)
					pos.x = 0;
				if(pos.x + size.w * scale < size.w)
					pos.x = - size.w * (scale - 1);
				if(pos.y > 0)
					pos.y = 0;
				if(pos.y + size.h * scale < size.h)
					pos.y = -size.h * (scale - 1);
		
				update();
				this.mouseZoomScroll = await false;
				// console.log("zoom mouse wheel" + this.zoomScale);
				$("#zoomScaleText").text(Math.floor(scale * 10) * 10+ "%");
			}); 
			function update() {
				target.css('transform','translate('+(pos.x)+'px,'+(pos.y)+'px) scale('+scale+','+scale+')');
			}
		},
		detectedBtnClicked(detectedDisplay) {
			this.detectedDisplayData = detectedDisplay;
			if(detectedDisplay.detectPerson == true) {
				$('#detect_info').css({'display': 'none'});
				$('#detected_person').css({'display': 'block'});
				$('#main_content').css({'min-height': 'calc(800px + 6rem)'});
				$('#right_sidebar').css({'min-height': 'calc(800px + 6rem)'});
        this.$store.commit('player/SET_IS_DETECT_CREATE', true);
			} else if(detectedDisplay.detectMotion == true) {
				this.$store.commit('player/SET_IS_DETECT_CREATE', true);
			} else if(detectedDisplay.detectSound == true) {
				this.$store.commit('player/SET_IS_DETECT_CREATE', true);
			} else if(detectedDisplay.detectComment == true) {
				this.$store.commit('player/SET_IS_DETECT_CREATE', true);
			}
		},
		removeDetected() {
			$('#detect_info').css({'display': 'block'});
			$('#detected_person').css({'display': 'none'});
			$('#main_content').css({'min-height': '800px'});
			$('#right_sidebar').css({'min-height': '800px'});
      this.$store.commit('player/SET_IS_DETECT_CREATE', false);
			this.detectedDisplayData.detectPerson = false;
		},
		displayTimeRow(value){
			// console.log(value);
			if(value == 'ムービー') {
				$('#main_content').css({'min-height': 'calc(800px + 4.8rem)'});
				$('#right_sidebar').css({'min-height': 'calc(800px + 4.8rem)'});
			}
			else {
				$('#main_content').css({'min-height': 'calc(800px + 7rem)'});
				$('#right_sidebar').css({'min-height': 'calc(800px + 7rem)'});
			}
		},
		createThumb(video, w, h) {
			let c = document.createElement("canvas"),  // create a canvas
				ctx = c.getContext("2d"),                // get context
				thumbImg = new Image();                  // final image
			c.width = w;                               // set size = thumb
			c.height = h;
			ctx.drawImage(video, 0, 0, w, h);          // draw in frame
			var base64Str = c.toDataURL();
			return base64Str; 
		},
		createImageAndConvertBlob(video, w, h) {
			let c = document.createElement("canvas"),  // create a canvas
				ctx = c.getContext("2d"),                // get context
				thumbImg = new Image();                  // final image
			c.width = w;                               // set size = thumb
			c.height = h;
			ctx.drawImage(video, 0, 0, w, h);          // draw in frame
			let base64Str = c.toDataURL();
		
			let imgData = atob(base64Str.split(',')[1]);
			let len = imgData.length;
			let buf = new ArrayBuffer(len); // 비트를 담을 버퍼를 만든다.
			let view = new Uint8Array(buf); // 버퍼를 8bit Unsigned Int로 담는다.
			let blob, i;
		
			for (i = 0; i < len; i++) {
				view[i] = imgData.charCodeAt(i) & 0xff; // 비트 마스킹을 통해 msb를 보호한다.
			}
			// Blob 객체를 image/png 타입으로 생성한다. (application/octet-stream도 가능)
			blob = new Blob([view], { type: 'image/png' });
			return blob; 
		},
		keyupFunc(event) {
			let key = event.keyCode;
			if (key === 37) { // 좌측 방향키
				this.videoRewind(this);
			} else if (key === 39) { // 우측 방향키
				this.videoForward(this);
			} else if (key === 32) { // 스페이스바
				if(this.videoPlayStatus) {
          this.videoPause();
          this.$store.commit('player/SET_VIDEO_PLAY_STATUS', false);
					this.playPauseBtnDom.innerHTML = "<img src='" + this.playImagePath + "' style='width:16px; height:16px;' />";
				} else {
          this.videoPlay();
          this.$store.commit('player/SET_VIDEO_PLAY_STATUS', true);
					this.playPauseBtnDom.innerHTML = "<img src='" + this.pauseImagePath + "' style='width:25px; height:25px;' />";
				}
			}
		},
		setSoundVolume(soundVolume) {
      this.player.volume(soundVolume / 100);
      if(this.$store.state.isMobile) { // Mobile
        if(soundVolume != 0) {
          this.player.muted(false);
          document.getElementsByClassName('mobile_sound_volume_btn')[0].innerHTML = "<img src='" + require(`@/assets/images/sound_max.png`) + "' style='width:2rem; height:2rem;' />";
        } 
				// volume이 0이라고 muted가 되진 않음
				// else {
        //   document.getElementsByClassName('mobile_sound_volume_btn')[0].innerHTML = "<img src='" + require(`@/assets/images/sound_min.png`) + "' style='width:2rem; height:2rem;' />";
        // }
      } else { // Web
			const button = this.player.controlBar.getChildById('volume_button');
			const soundButtonDom = button.el();
			if(soundVolume != 0) {
				this.player.muted(false);
        soundButtonDom.innerHTML = "<img src='" + require(`@/assets/images/sound_max.png`) + "' style='width:25px; height:25px;' />";
			}
			// else {
      //   soundButtonDom.innerHTML = "<img src='" + require(`@/assets/images/sound_min.png`) + "' style='width:25px; height:25px;' />";
			// }
		}
    },
    muteSoundVolume() {
			this.player.muted(true);
			if(this.$store.state.isMobile == true) {
        this.mobileSoundVolume = 0;
        // document.getElementsByClassName('mobile_sound_volume_btn')[0].innerHTML = "<img src='" + require(`@/assets/images/sound_min.png`) + "' style='width:2rem; height:2rem;' />";
				console.log('soundVolume', this.mobileSoundVolume);
      } else {
				const button = this.player.controlBar.getChildById('volume_button');
				const soundButtonDom = button.el();
				soundButtonDom.innerHTML = "<img src='" + require(`@/assets/images/sound_min.png`) + "' style='width:25px; height:25px;' />";
			}
    },
    muteMicVolume() {
      //set mic volume mute
    },
    setZoomScaleText(zoomScale) {
			this.mouseZoomScroll = false;
      this.zoomButtonDom.innerHTML = "<span id=\"zoomScaleText\">" + zoomScale * 10 + "%</span>";
    },
    hoverSoundVolume() {
      document.getElementById("sound_volume_change").style.display = 'flex';
    },
    hoverOutSoundVolume() {
      document.getElementById("sound_volume_change").style.display = 'none';
    },
    hoverZoom() {
      document.getElementById("zoom_change").style.display = 'flex';
    },
    hoverOutZoom() {
      document.getElementById("zoom_change").style.display = 'none';
    },
    micOn() {
      this.micActive = true;
      this.micButtonDom.innerHTML = "<img src='" + require(`@/assets/images/mic_on.png`) + "' style='width:27px; height:27px;' />";
      this.curretnMicIconPosition = $('.mic_btn').position().left + $('#example-video').position().left - 30;
      $("#mic_tooltip").css({'left': `${this.curretnMicIconPosition}px`});
      document.getElementById('mic_tooltip').style.display = 'block';
    },
		displayDetectMenu() {
      var rect = document.getElementsByClassName('detect_menu_btn')[0].getBoundingClientRect();
      $('#dialog_no_title').css({'top':rect.top - 140 + 'px'});
      this.detectMenuDialogVisible = true;
    },
		removeStrZero(px) {
			let str = px.toString();
			let result = str.substring(0, str.length -1) + '0';
			return parseInt(result);
		},
		timelineMouseWheelFunc(event) {
			// console.log(event.deltaX, event.deltaY, event.deltaFactor, this.timeLineScrollScale);
			const timeScales = ['10分','1時間','6時間','24時間','72時間'];
			let index = timeScales.indexOf(this.selectedTimeScale);

			if (event.deltaY > 0) {
				index = Math.max(0, index -1); //인덱스가 0보다 작아지지 않도록 조정
			} else {
				index = Math.min(timeScales.length - 1, index + 1); // 인덱스가 배열 길이보다 커지지 않도록 조정
			}
			this.selectedTimeScale = timeScales[index];
		},
		fetchDataTagAndSettingInfoAndPreset() {
			let params = {};
			this.getPresetList();
			this.fetchCameraSettingData();
			this.networkController.getTagList(params, this.streamData.contractCd, this.streamData.portNo)
			.then(async (res) => {
				console.log('%cTag List\n', "color:#008DD0;", res.data);
				this.tagList = res.data;
			}).catch(error => { });
			this.getCameraDeviceInfo();
		},
    fetchRecordingPeriod() {
			let params = {};
			this.networkController.getCameraRecordingPeriod(params, this.streamData.contractCd)
			.then(async (res) => {
				console.log('%crecording peroid\n', "color:#008DD0;", res.data);
        this.$store.commit('player/SET_RECORDING_PERIOD', res.data.recordingPeriod);
			}).catch(error => { });
    },
		fetchKvsMetric() {
			let setBeginDate = new Date(this.videoSegmentStartDateObj.getTime());
			let makeBeginDate = new Date(setBeginDate.setSeconds(setBeginDate.getSeconds() - this.colorBoxBeginTime))
			let setEndingDate = new Date(this.videoSegmentStartDateObj.getTime());
			let makeEndingDate = new Date(setEndingDate.setSeconds(setEndingDate.getSeconds() + this.colorBoxEndingTime));
			let params = {};
			this.networkController.getKvsMetric(params, this.streamData.streamName,
				makeBeginDate.toISOString(), makeEndingDate.toISOString(), this.shadowMatricPeriodValue)
			.then(async (res) => {
				console.log('%cVideo Metrics Data\n', "color:#008DD0;",res.data);
				this.metricList = res.data;
				this.metricList.forEach((item) => {
					let startPxValue = this.calculateBetweenTwoDate(this.videoSegmentStartDateObj, new Date(item.start)) * this.moveToCanvasPxValue;
					let endPxValue = this.calculateBetweenTwoDate(this.videoSegmentStartDateObj, new Date(item.end)) * this.moveToCanvasPxValue;
				});
			}).catch(error => { });
			this.fetchKvsMetricDate();
		},
		async fetchKvsMetricDate() {
			let nowPlaymode = this.playMode;
      if (nowPlaymode === PlayMode.WEBRTC_LIVE || nowPlaymode === PlayMode.PLAYBACK) {
        if (this.$refs.videoBox.offline) this.$refs.videoBox.offline.sendMessage('datelist');
        return;
      }
			
			let tempBeginDate = null;
			if (this.pickerDate != null) {
				tempBeginDate = new Date(this.pickerDate.substring(0, 4) + '', this.pickerDate.substring(5, 7) - 1 + '');
			} else {
				tempBeginDate = new Date(this.videoSegmentStartDateObj.getTime());
			}
			let offset = tempBeginDate.getTimezoneOffset() * 60000; // UTC time zone이기 때문에 발생하는 오차를 수정하기 위한 offset, ms단위라 60000곱해줌
			let kvsBeginDateOffset = new Date(tempBeginDate.getFullYear(), tempBeginDate.getMonth(), new Date().getDate() - this.recordingPeriod); // 계약기간
			// let kvsEndingDateOffset = new Date(tempBeginDate.getFullYear(), tempBeginDate.getMonth() + 1, 0, 23, 59, 0);
			let kvsEndingDateOffset = new Date();
			let kvsBeginDate = new Date(kvsBeginDateOffset - offset);
			let kvsEndingDate = new Date(kvsEndingDateOffset - offset);
		
			try {
				const res = await this.networkController.getKvsMetricDate({}, this.streamData.streamName,
					kvsBeginDate.toISOString(), kvsEndingDate.toISOString());
		
				console.log('%cVideo Metrics Date List\n', "color:#008DD0;", res.data);
				this.metricDateList = res.data;
				this.dates = [];
				const current = dayjs(new Date());
				const recordingPeriod = current.subtract(this.recordingPeriod + 1, 'day');
				res.data.forEach((item) => { // dates 배열에 날짜 추가
					if (recordingPeriod.isBefore(item.substring(0, 10))) this.dates.push(item.substring(0, 10));
				});
		
				// this.dates가 채워진 후에 changeSwipeDate를 호출
				this.changeSwipeDate();
				
		
				setTimeout(() => {
					let dd = this.playPoint;
					if (!dd) dd = new Date();
					const pp = dd.toISOString().substring(0, 10);
					let idx = this.dates.indexOf(pp);
					if (idx < 0) idx = this.dates.length - 1;
					this.$refs.dateSwiper.$swiper.slideTo(idx);
				}, 200);
			} catch (error) {
				console.error(error);
			}
		},
		async cameraSettingDataRefresh() {
			this.settingRefreshLoading = true;
			let params = {};
			// if(this.onDemand == false) this.getCameraThumbnail();
			// if (PlayMode.isLive(this.playMode)) this.getCameraThumbnail();
			// PlayMode가 KVS_ON_DEMAND인 경우에도 현재 시간일 수 있으므로, 판단하지 않고 그냥 썸네일 가져옴
			this.getCameraThumbnail();
			this.getPresetList();
			await this.getCameraDeviceInfo();
			this.fetchCameraSettingData().then(() => {
				this.settingRefreshLoading = false;
				this.cameraSettingDialogVisible = true;
			}).catch(error => {
				this.settingRefreshLoading = false;
			});
		},
		getCameraThumbnail() {
			if (!this.player) return;
			return new Promise(async (resolve, reject) => {
				try {
					const videoElement = document.getElementById("my-video");
					const blob = await this.createImageAndConvertBlob(document.getElementById(this.player.id() + "_html5_api"),
						videoElement.getBoundingClientRect().width, 
						videoElement.getBoundingClientRect().height);
					// URL 객체 생성
					const url = await URL.createObjectURL(blob);
					await this.$store.commit('setCameraThumbnail', url);
					resolve()
				} catch (error) {
					// 에러 발생 시 로그 출력
					console.error("에러 발생:", error);
					reject(error);
				}
			});
		},
		fetchCameraSettingData() {
			return new Promise((resolve, reject) => {
				let params = {};
				this.networkController.getCameraSettingData(params, this.streamData.contractCd, this.streamData.portNo)
				.then(async (res) => {
					console.log('%cCamera Setting Data\n', "color:#008DD0;", res.data);
          this.$store.commit('player/SET_CAMERA_SETTING', res.data);
					this.cameraSettingData = res.data;
					setTimeout(() => this.settingBtnDisable = false, 2000);
					resolve();
				}).catch(error => {
					reject();
				});
			});
		},
    async fetchHlsStreamingUrl() {
      return new Promise((resolve, reject) => {
        // this.streamData = this.$store.getters.getStreamInfo; // videoBox에서 props로 받아온 streamData이므로 assign하면 안됨.
				const type = this.$route.query.type;
        let params = {};
				if(type == 'bookmark' || type == 'event') { // bookmark, event 온디멘드 영상
					const createTime = decodeURIComponent(this.$route.query.createTime);
					let korTime = new Date(createTime.substring(0,19));

          let startTime = korTime.toISOString();
					this.makeVideoStartTime(startTime);
					this.networkController.getHlsStreamingUrl(params, this.streamData.streamName, startTime, "")
					.then( async (res) => {
						this.videoStreamingUrl = res.data.hlsstreamingSessionURL;
						await this.$store.commit('setVideoStreamingUrl', res.data.hlsstreamingSessionURL);
            this.$store.commit('player/SET_VIDEO_ERROR', VideoErrorStatus.NO_ERROR);
						resolve();
					}).catch(error => {
            this.$store.commit('player/SET_VIDEO_ERROR', VideoErrorStatus.OFFLINE);
						reject();
					}).finally(() => {
						// this.videoLoading = false;
            this.videoPlay();
					});
				} else if(type == 'clip') { // 클립 온디멘드 영상
    			const beginTime = decodeURIComponent(this.$route.query.beginTime);
    			const endTime = decodeURIComponent(this.$route.query.endTime);
					let korBeginTime = new Date(beginTime.substring(0,19));
					let korEndTime = new Date(endTime.substring(0,19));

          let startTime = korBeginTime.toISOString();
          this.showClipTab = true; //우측 메뉴에 클립 표시
          this.makeVideoStartTime(startTime);
					this.networkController.getHlsStreamingUrl(params, this.streamData.streamName, startTime, "")
					.then( async (res) => {
						this.videoStreamingUrl = res.data.hlsstreamingSessionURL;
						await this.$store.commit('setVideoStreamingUrl', res.data.hlsstreamingSessionURL);
            this.$store.commit('player/SET_VIDEO_ERROR', VideoErrorStatus.NO_ERROR);
						resolve();
					}).catch(error => {
            this.$store.commit('player/SET_VIDEO_ERROR', VideoErrorStatus.OFFLINE);
						reject();
					}).finally(() => {
						// this.videoLoading = false;
            this.videoPlay();
					});
				} else { // 라이브 영상
					this.makeVideoStartTime(new Date());
					this.networkController.getHlsStreamingUrl(params, this.streamData.streamName, '', '')
					.then( async (res) => {
						this.videoStreamingUrl = res.data.hlsstreamingSessionURL;
						await this.$store.commit('setVideoStreamingUrl', res.data.hlsstreamingSessionURL);
            this.$store.commit('player/SET_VIDEO_ERROR', VideoErrorStatus.NO_ERROR);
						resolve();
					}).catch(error => {
            this.$store.commit('player/SET_VIDEO_ERROR', VideoErrorStatus.OFFLINE);
						reject();
					}).finally(() => {
						// this.videoLoading = false;
            this.videoPlay();
					});
				}
      });
    },
		getCameraDeviceInfo() {
			return new Promise((resolve, reject) => {
			  let params = {};
			  this.networkController.getCameraInfo(params, this.streamData.contractCd, this.streamData.portNo)
        .then(async (res) => {
          console.log('%cCamera Device Info\n', "color:#008DD0;", res.data);
			  	this.cameraInfo = res.data;
					this.streamData.cameraName = res.data.cameraName;
          if(res.data.ptz.continuousMove.zoom.enable) this.ptzZoomEnable = true;
          if(res.data.ptz.absoluteMove.panTilt.enable) this.ptzPanTiltEnable = true;
          if(res.data.ptz.continuousMove.panTilt.enable) this.ptzMoveEnable = true;
					this.eventDetectEnable = res.data.setting.event.motion != undefined
        		? res.data.setting.event.motion.enabled : false;
          resolve();
        }).catch(error => {
					console.log(error)
          reject();
        });
      });
		},
    getCameraEventByOptions(options) {
      const cd = options.cd;
      const no = options.no;
      const pp = options.pp;
      return new Promise((resolve, reject) => {
        const setBeginDate = new Date();
        const makeBeginDate = new Date(setBeginDate.setDate(setBeginDate.getDate() - this.recordingPeriod));
        const setEndingDate = new Date(pp.getTime());
        const makeEndingDate = new Date(setEndingDate.setDate(setEndingDate.getDate() + 2));
        let params = {};
        this.networkController.getCameraEventData(params, cd, no, '',
          makeBeginDate.toISOString(), makeEndingDate.toISOString())
        .then(res => {
          const motionList = [];
          const soundList = [];
          const posAList = [];
          res.data.forEach(ele => {
            if (ele.type != null && ele.type === 'Motion') motionList.push(new Date(ele.createTime));
            else if (ele.type != null && ele.type === 'Sound') soundList.push(new Date(ele.createTime));
            else if (ele.type != null && ele.type === 'Void') posAList.push(new Date(ele.createTime));
          });
          resolve({
            motionList: motionList,
            soundList: soundList,
            posAList: posAList,
          })
        })
        .catch(error => {
          console.log(error);
          reject();
        });
      });
		},
		getCameraEvent() {
      const options = {
        cd: this.streamData.contractCd,
        no: this.streamData.portNo,
        pp: this.playPoint ? this.playPoint : new Date()
      }
      return this.getCameraEventByOptions(options);
		},
		motionDetectEyeFunc(status) {
      if(status == 'close') {
        this.motionDetectDisplay = false;
      } else { // open
        this.motionDetectDisplay = true;
      }
    },
		soundDetectEyeFunc(status) {
      if(status == 'close') {
        this.soundDetectDisplay = false;
      } else { // open
        this.soundDetectDisplay = true;
      }
    },
    posADetectEyeFunc(status) {
      if(status == 'close') {
        this.posADetectDisplay = false;
      } else {
        this.posADetectDisplay = true;
      }
    },
    hidePtzControlFunc() {
      if(this.$store.state.isMobile == false) this.player.controlBar.children_[8].hide();
			this.$store.dispatch('player/updatePtzControlOn', false);
      // this.ptzControlOn = false;
    },
		clickHorizontalPtzFunc(event, element) { // Pan
			const rect = element.getBoundingClientRect();
			// 마우스 이벤트와 터치 이벤트에서의 X 좌표를 처리
  		const x = event.clientX !== undefined ? 
				event.offsetX : 
				event.touches[0].clientX - rect.left;
			const width = rect.width;
			const clickHorizontalPtzPositionParamsValue = (x / width) * 2 - 1;
			this.ptzClickMove('Pan', clickHorizontalPtzPositionParamsValue);
			/*
			if(event.pageX > this.ptzHPointInitPxValue) { // +1
				let offset = event.pageX - this.ptzHPointInitPxValue;
				let result = (offset / 8) * 0.04;
				let clickHorizontalPtzPositionParamsValue = result.toFixed(2);
				// console.log(clickHorizontalPtzPositionParamsValue);
				this.ptzClickMove('Pan', clickHorizontalPtzPositionParamsValue);
			} else { // -1
				let offset = this.ptzHPointInitPxValue - event.pageX;
				let result = -((offset / 8) * 0.04);
				let clickHorizontalPtzPositionParamsValue = result.toFixed(2);
				// console.log(clickHorizontalPtzPositionParamsValue);
				this.ptzClickMove('Pan', clickHorizontalPtzPositionParamsValue);
			}
			*/
		},
		clickVerticalPtzFunc(event) { // Tilt
			let result = ((this.ptzVPointInitPxValue - event.offsetY) / 8.8) * 0.04;
			let clickVerticalPtzPositionParamsValue = result.toFixed(2);
			// console.log(result.toFixed(2));
			if(result.toFixed(2) >= 0) clickVerticalPtzPositionParamsValue = clickVerticalPtzPositionParamsValue * 0.764;
			this.ptzClickMove('Tilt', clickVerticalPtzPositionParamsValue);
		},
		touchHorizontalPtzFunc(event) {
			if(event.touches[0].pageX > this.initTimeLinePosition) { // +1
				let offset = event.touches[0].pageX - this.initTimeLinePosition;
				let result = offset / 150;
				let clickHorizontalPtzPositionParamsValue = result.toFixed(2);
				// console.log(clickHorizontalPtzPositionParamsValue);
				this.ptzClickMove('Pan', clickHorizontalPtzPositionParamsValue);
			} else { // -1
				let offset = this.initTimeLinePosition - event.touches[0].pageX;
				let result = -(offset / 150);
				let clickHorizontalPtzPositionParamsValue = result.toFixed(2);
				// console.log(clickHorizontalPtzPositionParamsValue);
				this.ptzClickMove('Pan', clickHorizontalPtzPositionParamsValue);
			}
		},
		touchVerticalPtzFunc(event) {
			let result = ((this.ptzVPointInitPxValue - event.touches[0].pageY + 90) / 115);
			let clickVerticalPtzPositionParamsValue = result.toFixed(2);
			// console.log(result.toFixed(2));
			this.ptzClickMove('Tilt', clickVerticalPtzPositionParamsValue);
		},
		mobileVideoSeekBack() {
			this.videoRewind(this);
		},
		mobileVideoPlayPause() {
			if(this.videoPlayStatus == true) {
        this.videoPause();
        this.$store.commit('player/SET_VIDEO_PLAY_STATUS', false);
			} else {
        this.videoPlay();
        this.$store.commit('player/SET_VIDEO_PLAY_STATUS', true);
			}
		},
		mobileVideoSeekFoward() {
			this.videoForward(this);
		},
		mobileVideoFullscreen() {
			if(this.videoFullScreen) {
				this.player.exitFullscreen();
				this.videoFullScreen = false;
			} else {
				this.player.requestFullscreen();
				this.videoFullScreen = true;
			}
		},
		async mobileMakeBookMark() {
			this.makeNewBookmark = true;
			await this.newBookMark();
			this.getBookMarkListToStore();
		},
		mobileMakeClip() {
			this.$store.commit('player/SET_IS_CLIP_CREATE', true);
			this.displayClip();
		},
		mobilePtz() {
			// this.ptzControlOn = !this.ptzControlOn;
			this.$store.dispatch('player/togglePtzControlOn');
			if(this.videoFullScreen) {
				this.player.exitFullscreen();
				this.videoFullScreen = false;
			}
		},
		calculateStopDragTimeLivePosition(stopDragPositionTimeDate) {
			// 온디멘드 영상에서 타임라인을 미래로 드래그 했는지 여부 확인하는 함수
			let dif = stopDragPositionTimeDate.getTime() - new Date().getTime();
			let dif_second = dif / 1000; // 밀리세컨드를 초(second)로
			if(dif_second >= 0) return true; // 0보다 크면 drag포인트가 미래에서 멈춘것
			else return false; // 아직 과거
		},
    processDelayOnPurpose(millisecond) {
      return new Promise((resolve, reject) => setTimeout(() => resolve(true), millisecond));
    },
		isErrorStatus(error) {
			return VideoErrorStatus.isErrorStatus(error);
		},
		isOfflineStatus(error) {
      const isAvailable = VideoErrorStatus.isOfflineStatus(error);
      if (isAvailable) this.$store.dispatch('player/hideLoading');
      return isAvailable;
    },
    isExceedMaxSessionStatus(error) {
      const isAvailable = VideoErrorStatus.isExceedMaxSessionStatus(error);
      if (isAvailable) this.$store.dispatch('player/hideLoading');
      return isAvailable;
    },
	}
}
export default videoPlayerMixin;